module.exports = __webpack_public_path__ + "static/media/Prohibited category list.140a924d.pdf";